function initializeBootstrapElements() {
  // Variables for keeping track of header collapsibles
  const $nonHeaderContent = $('main, footer');
  const $headerCollapsibles = $('[data-bs-parent="#header-collapsibles"]');
  let activeHeaderCollapsibleCount = 0;

  // Gets a trap focus keydown event using the dialog and initiator elements
  function getTrapFocusKeydownEvent(dialogElement, initiatorElement) {

    let focusableElements = dialogElement.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
    let firstFocusableElement = focusableElements[0];
    let lastFocusableElement = focusableElements[focusableElements.length - 1];

    return function (e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) /* shift + tab */ {
          if (document.activeElement === firstFocusableElement) {
            initiatorElement.focus();
            e.preventDefault();
          } else if (document.activeElement === initiatorElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else /* tab */ {
          if (document.activeElement === lastFocusableElement) {
            initiatorElement.focus();
            e.preventDefault();
          } else if (document.activeElement === initiatorElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      }
    }
  };

  // On header collapsible show event
  $headerCollapsibles.on('show.bs.collapse', function (e) {
    if ($headerCollapsibles.is(e.target)) {
      activeHeaderCollapsibleCount++;

      // Dim the non-header content
      $nonHeaderContent.css('filter', 'brightness(0.4)');

      // Get the collapsible initiator
      let dialogId = $(e.target).attr('id');
      let initiatorElement = $('[data-bs-target="#' + dialogId + '"]').get(0);

      // Add trap focus event listener
      $([e.target, initiatorElement]).on('keydown.trapFocus', getTrapFocusKeydownEvent(e.target, initiatorElement));
    }
  });

  // On header collapsible hide event
  $headerCollapsibles.on('hide.bs.collapse', function (e) {
    if ($headerCollapsibles.is(e.target)) {
      activeHeaderCollapsibleCount--;

      if (activeHeaderCollapsibleCount === 0) {
        // Remove dim from non-header content
        $nonHeaderContent.css('filter', '');

        // Get the collapsible initiator
        let dialogId = $(e.target).attr('id');
        let initiatorElement = $('[data-bs-target="#' + dialogId + '"]').get(0);

        // Move focus back to initiator
        initiatorElement.focus();

        // Remove trap focus event listener
        $([e.target, initiatorElement]).off('keydown.trapFocus');
      }
    }
  });

  // Hide header collapsibles when user clicks outside them
  $(document).click(function (e) {
    if (activeHeaderCollapsibleCount > 0) {
      const $target = $(e.target);
      if ($target.closest($headerCollapsibles).length === 0 && $target.data('data-bs-toggle') !== 'collapse') {
        $headerCollapsibles.collapse('hide');
      }
    }
  });

  // Hide header collapsibles on escape key
  $(document).keydown(function (e) {
    if (activeHeaderCollapsibleCount > 0) {
      if (e.key === 'Escape') {
        $headerCollapsibles.collapse('hide');
      }
    }
  });

  // Don't hide "keep open" dropdown menus when they are clicked inside
  $(document).on('click', '.dropdown-menu.dropdown-menu-keep-open', function (e) {
    e.stopPropagation();
  });

  $('.rate-datarac').on('shown.bs.collapse hide.bs.collapse',  function (e) {
    var loc = scrollCenter($(e.target));
      $('html, body').animate({
      scrollTop: loc
    }, 500);
  });
  
  function scrollCenter(target)
  {
    var elOffset = target.offset().top;
    var windowHeight = $(window).height();
    var offset;

    offset = elOffset - (windowHeight / 2) + 75; //adjust for the 'x'

    return offset;
  }
}

//
// Initialize Bootstrap JavaScript
//

document.addEventListener('DOMContentLoaded', (event) => {
  initializeBootstrapElements();
})
